import * as React from 'react';
import { ErrorOutline, Refresh } from '@mui/icons-material';
import { Button } from 'components';
import { TErrorDisplay } from './ErrorDisplay.types';
import './ErrorDisplay.styled.scss';

export const ErrorDisplay: TErrorDisplay = ({
  title = 'Помилка завантаження',
  text = 'На жаль, сталася помилка при завантаженні товарів. Будь ласка, спробуйте пізніше',
  onReload,
}) => {
  return (
    <div className="error-display">
      <ErrorOutline className="error-display__icon" />
      <h3 className="error-display__title">{title}</h3>
      <p className="error-display__text">{text}</p>
      {onReload && (
        <Button
          variant="contained"
          startIcon={<Refresh />}
          onClick={onReload}
          className="error-display__retry-button"
        >
          Спробувати знову
        </Button>
      )}
    </div>
  );
};
